import { createI18n } from 'vue-i18n'
import en from '~/public/lang/en.json'
import th from '~/public/lang/th.json'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'th',
  messages: {
    en,
    th
  }
})

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(i18n)
})

export {
  i18n
}
